import script from "./ScrollTopButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScrollTopButton.vue?vue&type=script&lang=ts&setup=true"

import "./ScrollTopButton.vue?vue&type=style&index=0&id=6bfad5fc&lang=scss"

const __exports__ = script;

export default __exports__